import { useState, useCallback, useRef, useEffect } from 'react';

function useNotification() {
  const [notification, setNotification] = useState(null);
  const notificationIdRef = useRef(0);
  const pendingNotificationRef = useRef(null);

  const showNotification = useCallback((message, type = 'info') => {
    // Cancel any pending notification
    if (pendingNotificationRef.current) {
      clearTimeout(pendingNotificationRef.current);
    }

    // Clear current notification
    setNotification(null);

    // Schedule new notification with slight delay
    pendingNotificationRef.current = setTimeout(() => {
      notificationIdRef.current += 1;
      setNotification({
        id: notificationIdRef.current,
        message,
        type
      });
      pendingNotificationRef.current = null;
    }, 10);
  }, []);

  const hideNotification = useCallback(() => {
    setNotification(null);
  }, []);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (pendingNotificationRef.current) {
        clearTimeout(pendingNotificationRef.current);
      }
    };
  }, []);

  return {
    notification,
    showNotification,
    hideNotification
  };
}

export default useNotification;